"use strict";

exports.__esModule = true;
exports.UploadManager = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _utils = require("./utils");

var _pool = require("./pool");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BLOCK_SIZE = 4 * 1024 * 1024;

var UploadManager = exports.UploadManager = function () {
  function UploadManager(options, handlers, statisticsLogger) {
    var _this = this;

    (0, _classCallCheck3["default"])(this, UploadManager);

    this.config = (0, _assign2["default"])({
      useCdnDomain: true,
      disableStatisticsReport: false,
      retryCount: 3,
      checkByMD5: false,
      uphost: null,
      forceDirect: false,
      concurrentRequestLimit: 3,
      region: null
    }, options.config);
    this.putExtra = (0, _assign2["default"])({
      fname: "",
      params: {},
      mimeType: null
    }, options.putExtra);
    this.statisticsLogger = statisticsLogger;
    this.progress = null;
    this.xhrList = [];
    this.xhrHandler = function (xhr) {
      return _this.xhrList.push(xhr);
    };
    this.aborted = false;
    this.file = options.file;
    this.key = options.key;
    this.token = options.token;
    this.onData = function () {};
    this.onError = function () {};
    this.onComplete = function () {};
    this.retryCount = 0;
    (0, _assign2["default"])(this, handlers);
  }

  UploadManager.prototype.putFile = function putFile() {
    var _this2 = this;

    this.aborted = false;
    if (!this.putExtra.fname) {
      this.putExtra.fname = this.file.name;
    }
    if (this.putExtra.mimeType && this.putExtra.mimeType.length && !(0, _utils.isContainFileMimeType)(this.file.type, this.putExtra.mimeType)) {
      var err = new Error("file type doesn't match with what you specify");
      this.onError(err);
      return;
    }
    var upload = (0, _utils.getUploadUrl)(this.config, this.token).then(function (res) {
      _this2.uploadUrl = res;
      _this2.uploadAt = new Date().getTime();

      if (_this2.config.forceDirect) {
        return _this2.directUpload();
      }

      return _this2.file.size > BLOCK_SIZE ? _this2.resumeUpload() : _this2.directUpload();
    });
    upload.then(function (res) {
      _this2.onComplete(res.data);
      if (!_this2.config.disableStatisticsReport) {
        _this2.sendLog(res.reqId, 200);
      }
    }, function (err) {

      _this2.clear();
      if (err.isRequestError && !_this2.config.disableStatisticsReport) {
        var reqId = _this2.aborted ? "" : err.reqId;
        var code = _this2.aborted ? -2 : err.code;
        _this2.sendLog(reqId, code);
      }

      var needRetry = err.isRequestError && err.code === 0 && !_this2.aborted;
      var notReachRetryCount = ++_this2.retryCount <= _this2.config.retryCount;
      if (needRetry && notReachRetryCount) {
        _this2.putFile();
        return;
      }

      _this2.onError(err);
    });
    return upload;
  };

  UploadManager.prototype.clear = function clear() {
    this.xhrList.forEach(function (xhr) {
      return xhr.abort();
    });
    this.xhrList = [];
  };

  UploadManager.prototype.stop = function stop() {
    this.clear();
    this.aborted = true;
  };

  UploadManager.prototype.sendLog = function sendLog(reqId, code) {
    this.statisticsLogger.log({
      code: code,
      reqId: reqId,
      host: (0, _utils.getDomainFromUrl)(this.uploadUrl),
      remoteIp: "",
      port: (0, _utils.getPortFromUrl)(this.uploadUrl),
      duration: (new Date().getTime() - this.uploadAt) / 1000,
      time: Math.floor(this.uploadAt / 1000),
      bytesSent: this.progress ? this.progress.total.loaded : 0,
      upType: "jssdk-h5",
      size: this.file.size
    }, this.token);
  };

  // 直传


  UploadManager.prototype.directUpload = function directUpload() {
    var _this3 = this;

    var formData = new FormData();
    formData.append("file", this.file);
    formData.append("token", this.token);
    if (this.key != null) {
      formData.append("key", this.key);
    }
    formData.append("fname", this.putExtra.fname);
    (0, _utils.filterParams)(this.putExtra.params).forEach(function (item) {
      return formData.append(item[0], item[1]);
    });

    return (0, _utils.request)(this.uploadUrl, {
      method: "POST",
      body: formData,
      onProgress: function onProgress(data) {
        _this3.updateDirectProgress(data.loaded, data.total);
      },
      onCreate: this.xhrHandler
    }).then(function (res) {
      _this3.finishDirectProgress();
      return res;
    });
  };

  // 分片上传


  UploadManager.prototype.resumeUpload = function resumeUpload() {
    var _this4 = this;

    this.loaded = {
      mkFileProgress: 0,
      chunks: null
    };

    this.ctxList = [];
    this.localInfo = (0, _utils.getLocalFileInfo)(this.file);
    this.chunks = (0, _utils.getChunks)(this.file, BLOCK_SIZE);
    this.initChunksProgress();

    var pool = new _pool.Pool(function (chunkInfo) {
      return _this4.uploadChunk(chunkInfo);
    }, this.config.concurrentRequestLimit);
    var uploadChunks = this.chunks.map(function (chunk, index) {
      return pool.enqueue({ chunk: chunk, index: index });
    });
    var result = _promise2["default"].all(uploadChunks).then(function () {
      return _this4.mkFileReq();
    });
    result.then(function (res) {
      (0, _utils.removeLocalFileInfo)(_this4.file);
    }, function (err) {
      // ctx错误或者过期情况下
      if (err.code === 701) {
        (0, _utils.removeLocalFileInfo)(_this4.file);
        return;
      }
    });
    return result;
  };

  UploadManager.prototype.uploadChunk = function uploadChunk(chunkInfo) {
    var _this5 = this;

    var index = chunkInfo.index,
        chunk = chunkInfo.chunk;

    var info = this.localInfo[index];
    var requestUrl = this.uploadUrl + "/mkblk/" + chunk.size;

    var savedReusable = info && !(0, _utils.isChunkExpired)(info.time);
    var shouldCheckMD5 = this.config.checkByMD5;
    var reuseSaved = function reuseSaved() {
      _this5.updateChunkProgress(chunk.size, index);
      _this5.ctxList[index] = { ctx: info.ctx, size: info.size, time: info.time, md5: info.md5 };
      return _promise2["default"].resolve(null);
    };

    if (savedReusable && !shouldCheckMD5) {
      return reuseSaved();
    }

    return (0, _utils.computeMd5)(chunk).then(function (md5) {

      if (savedReusable && md5 === info.md5) {
        return reuseSaved();
      }

      var headers = (0, _utils.getHeadersForChunkUpload)(_this5.token);
      var onProgress = function onProgress(data) {
        _this5.updateChunkProgress(data.loaded, index);
      };
      var onCreate = _this5.xhrHandler;
      var method = "POST";

      return (0, _utils.request)(requestUrl, {
        method: method,
        headers: headers,
        body: chunk,
        onProgress: onProgress,
        onCreate: onCreate
      }).then(function (response) {
        // 在某些浏览器环境下，xhr 的 progress 事件无法被触发，progress 为 null，这里在每次分片上传完成后都手动更新下 progress
        onProgress({ loaded: chunk.size });

        _this5.ctxList[index] = {
          time: new Date().getTime(),
          ctx: response.data.ctx,
          size: chunk.size,
          md5: md5
        };
        (0, _utils.setLocalFileInfo)(_this5.file, _this5.ctxList);
      });
    });
  };

  UploadManager.prototype.mkFileReq = function mkFileReq() {
    var _this6 = this;

    var putExtra = (0, _assign2["default"])({ mimeType: "application/octet-stream" }, this.putExtra);

    var requestUrL = (0, _utils.createMkFileUrl)(this.uploadUrl, this.file, this.key, putExtra);

    var body = this.ctxList.map(function (value) {
      return value.ctx;
    }).join(",");
    var headers = (0, _utils.getHeadersForMkFile)(this.token);
    var onCreate = this.xhrHandler;
    var method = "POST";
    return (0, _utils.request)(requestUrL, { method: method, body: body, headers: headers, onCreate: onCreate }).then(function (res) {
      _this6.updateMkFileProgress(1);
      return _promise2["default"].resolve(res);
    });
  };

  UploadManager.prototype.updateDirectProgress = function updateDirectProgress(loaded, total) {
    // 当请求未完成时可能进度会达到100，所以total + 1来防止这种情况出现
    this.progress = { total: this.getProgressInfoItem(loaded, total + 1) };
    this.onData(this.progress);
  };

  UploadManager.prototype.finishDirectProgress = function finishDirectProgress() {
    // 在某些浏览器环境下，xhr 的 progress 事件无法被触发，progress 为 null， 这里 fake 下
    if (!this.progress) {
      this.progress = { total: this.getProgressInfoItem(this.file.size, this.file.size) };
      this.onData(this.progress);
      return;
    }

    var total = this.progress.total;
    this.progress = { total: this.getProgressInfoItem(total.loaded + 1, total.size) };
    this.onData(this.progress);
  };

  UploadManager.prototype.initChunksProgress = function initChunksProgress() {
    this.loaded.chunks = this.chunks.map(function (_) {
      return 0;
    });
    this.notifyResumeProgress();
  };

  UploadManager.prototype.updateChunkProgress = function updateChunkProgress(loaded, index) {
    this.loaded.chunks[index] = loaded;
    this.notifyResumeProgress();
  };

  UploadManager.prototype.updateMkFileProgress = function updateMkFileProgress(progress) {
    this.loaded.mkFileProgress = progress;
    this.notifyResumeProgress();
  };

  UploadManager.prototype.notifyResumeProgress = function notifyResumeProgress() {
    var _this7 = this;

    this.progress = {
      total: this.getProgressInfoItem((0, _utils.sum)(this.loaded.chunks) + this.loaded.mkFileProgress, this.file.size + 1),
      chunks: this.chunks.map(function (chunk, index) {
        return _this7.getProgressInfoItem(_this7.loaded.chunks[index], chunk.size);
      })
    };
    this.onData(this.progress);
  };

  UploadManager.prototype.getProgressInfoItem = function getProgressInfoItem(loaded, size) {
    return {
      loaded: loaded,
      size: size,
      percent: loaded / size * 100
    };
  };

  return UploadManager;
}();


//////////////////
// WEBPACK FOOTER
// ./src/upload.js
// module id = 92
// module chunks = 0